import React from "react";
import { styled } from "../stitches.config";
import Centered from "../components/Centered";
import { H2 } from "./Typography";

export const AlertTitle = styled(H2, {
  textAlign: "center",
});

export const AlertMessage = styled("p", {
  marginBottom: "$5",
  textAlign: "center",
});

export const AlertWrapper = styled("div", {
  padding: "$6",
  borderRadius: "$3",
  border: "1px solid white",
  background: "$menuBeige",
  maxWidth: "20rem",
  variants: {
    size: {
      small: {
        padding: "$1",
      },
    },
  },
});

function Alert({ children }: React.PropsWithChildren<{}>) {
  return (
    <Centered>
      <AlertWrapper>{children}</AlertWrapper>
    </Centered>
  );
}

export function AlertBanner({ children }: React.PropsWithChildren<{}>) {
  return (
    <Banner>
      <AlertBannerWrapper>{children}</AlertBannerWrapper>
    </Banner>
  );
}

const AlertBannerWrapper = styled("div", {
  pointerEvents: "auto",
  cursor: "default",
  padding: "$2",
  fontSize: "$3",
  background: "$transparentBlack",
  color: "white",
  borderRadius: "$2",
});

const Banner = styled("div", {
  top: "$navBarHeight",
  paddingTop: "$2",
  position: "fixed",
  left: 0,
  right: 0,
  display: "grid",
  placeItems: "center",
  pointerEvents: "none",
});

export default Alert;
